// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';

// Custom hook for scroll indicator logic
export const useScrollIndicator = (containerRef, docs) => {
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);

  useEffect(() => {
    const checkScrollability = () => {
      if (containerRef.current) {
        const { scrollHeight, clientHeight, scrollTop } = containerRef.current;
        const isScrollable = scrollHeight > clientHeight;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10; // 10px threshold

        // Show indicator if scrollable and not at bottom
        setShowScrollIndicator(isScrollable && !isAtBottom);
      }
    };

    const handleScroll = () => {
      checkScrollability();
    };

    // Check on mount and when docs change
    checkScrollability();

    if (containerRef.current) {
      containerRef.current.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', checkScrollability);
    }

    return () => {
      if (containerRef.current) {
        containerRef.current.removeEventListener('scroll', handleScroll);
      }
      window.removeEventListener('resize', checkScrollability);
    };
  }, [docs, containerRef]);

  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  };

  return { showScrollIndicator, scrollToBottom };
};
